document.addEventListener('DOMContentLoaded', function() { // Ensure the DOM is fully loaded
  
    const klaviyoTriggers = document.querySelectorAll('.klaviyo-trigger');
    const klaviyoPublicKey = "JyHqWZ"; // Make sure this is correctly set in your theme settings

    // Handle escape key presses globally
  document.addEventListener('keydown', function(event) {
    if (event.key === 'Escape') {
      // Find any visible Klaviyo modals
      const visibleModals = document.querySelectorAll('[id^="klaviyo-modal-"]');
      visibleModals.forEach(modal => {
        if (modal.style.display === 'block') {
          closeKlaviyoModal(modal.id);
        }
      });
    }
  });

    klaviyoTriggers.forEach(trigger => {
      trigger.addEventListener('click', () => {
        const productId = trigger.dataset.productId;
        const variantId = trigger.dataset.variantId;
        const productTitle = trigger.dataset.productTitle;

        // Create the modal dynamically for each product
        const modalId = `klaviyo-modal-${productId}`;  // Unique ID for each modal
        let klaviyoModal = document.getElementById(modalId);

        if (!klaviyoModal) { // Create the modal if it doesn't exist
          klaviyoModal = document.createElement('div');
          klaviyoModal.id = modalId;
          klaviyoModal.style.cssText = `display: none; position: fixed; z-index: 10000; top: 0; left: 0; width: 100%; height: 100%; background-color: rgba(0, 0, 0, 0.65);`;
          klaviyoModal.innerHTML = `
            <div style="background-color: white; margin: 15% auto; padding: 20px; border: 1px solid #888; width: 80%; max-width: 600px; position: relative; border-radius: 3px; padding: 30px 40px;">
              <button style="position: absolute; top: 7px; right: 15px; font-size: 30px; font-weight: 700; line-height:1; cursor: pointer; color: #ccc; -webkit-appearance: none; background: none; border: none;" onclick="closeKlaviyoModal('${modalId}')">&times;</button>
              <h3>${productTitle}</h3> <p style="margin-bottom: 1rem;">Receive a notification when this product is available.</p>
              <form id="klaviyo-subscribe-form-${productId}" style="display: flex; flex-direction: column; gap: 30px;">
                <input type="email" id="klaviyo-email-${productId}" placeholder="Email" required aria-label="Email" style="font-size: 14px; height: 46px; padding: 10px 16px; line-height: 1.3333333; background-color: #fff; background-image: none; border: 1px solid #ccc; border-radius: 2px; box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075); transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;">
                <button type="submit" class="button">Notify Me</button>
                <div id="error_message-${productId}" class="error_message alert alert-danger" style="display: none;"></div>
              <div id="completed_message-${productId}" class="completed_message alert alert-success" style="display: none;">You will be notified when this item is back in stock. <a href="#" onclick="closeKlaviyoModal('${modalId}')" style="color: #2a1103;">Close</a></div>
              </form>
            </div>
          `;
          document.body.appendChild(klaviyoModal);

        // Add click event to close when clicking outside the modal content
        klaviyoModal.addEventListener('click', function(event) {
          // If the click is directly on the modal background (not its children)
          if (event.target === klaviyoModal) {
            closeKlaviyoModal(modalId);
          }
        });
      }

        klaviyoModal.style.display = 'block';

        setTimeout(() => {
          const klaviyoEmail = document.getElementById(`klaviyo-email-${productId}`);
          if (klaviyoEmail) {
            klaviyoEmail.focus();
          }
        }, 200);

        const klaviyoForm = document.getElementById(`klaviyo-subscribe-form-${productId}`);
        const klaviyoEmail = document.getElementById(`klaviyo-email-${productId}`);
        const errorMessage = document.getElementById(`error_message-${productId}`);
        const completedMessage = document.getElementById(`completed_message-${productId}`);

        klaviyoForm.addEventListener('submit', (event) => {
          event.preventDefault();
          const email = klaviyoEmail.value;

          const payload = {
            "data": {
              "type": "back-in-stock-subscription",
              "attributes": {
                "profile": {
                  "data": {
                    "type": "profile",
                    "attributes": {
                      "email": email
                    }
                  }
                },
                "channels": ["EMAIL"]
              },
              "relationships": {
                "variant": {
                  "data": {
                    "type": "catalog-variant",
                    "id": `$shopify:::$default:::${variantId}`
                  }
                }
              }
            }
          };

          var requestOptions = {
            method: 'POST',
            headers: {
              "Content-Type": "application/json",
              "revision": "2024-06-15"
            },
            body: JSON.stringify(payload),
          };

          errorMessage.style.display = 'none'; // Hide any previous errors
          completedMessage.style.display = 'none'; // Hide any previous success message

          fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${klaviyoPublicKey}`, requestOptions)
            .then(response => {
              if (response.status === 202) {
                completedMessage.style.display = 'block';
                klaviyoForm.reset();
              } else {
                response.json().then(errorData => {
                  console.error("Klaviyo API Error:", errorData);
                  errorMessage.textContent = "There was an error subscribing. Please try again."; // Display error message
                  errorMessage.style.display = 'block';
                });
              }
            })
            .catch(error => {
              console.error("Fetch Error:", error);
              errorMessage.textContent = "There was a network error. Please try again."; // Display error message
              errorMessage.style.display = 'block';
            });
        });

      });
    });

    window.closeKlaviyoModal = function(modalId) {
      const modal = document.getElementById(modalId);
      if (modal) {
        modal.style.display = 'none';
        const errorMessage = modal.querySelector('.error_message');
        const completedMessage = modal.querySelector('.completed_message');
        if (errorMessage) errorMessage.style.display = 'none'; // Hide error on close
        if (completedMessage) completedMessage.style.display = 'none'; // Hide success on close
      }
    };

  });